import { Uuid } from '@hidat/huijs-common';
import { Expose, Type } from 'class-transformer';
import { PlayerInstanceInterface, ProfileSettingsInterface } from '@splixer/common';
import * as dayjs from 'dayjs';
import { PlayerProfile } from './player-listener-profile.model';
import { PlayerMix } from './player-mix.model';
import { PlayerListenerItem } from './player-listener-item.model';

export class PlayerInstance implements PlayerInstanceInterface {
  @Expose({ name: 'uid' })
  uid: Uuid | undefined = undefined;

  // Guid
  @Expose({ name: 'listener_id' })
  listenerId: Uuid | undefined;
  @Expose()
  @Type(() => PlayerProfile)
  _profile: PlayerProfile | undefined;
  @Expose()
  @Type(() => PlayerListenerItem)
  _listenerItems: PlayerListenerItem [] | undefined;
  @Expose()
  @Type(() => PlayerMix)
  _recents: PlayerMix [] | undefined;

  // Keep compiler happy
  id: number | undefined;
  createdAt: dayjs.Dayjs | undefined;
  updatedAt: dayjs.Dayjs | undefined;
}
